export default "__VITE_ASSET__4b22e1de__"